import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "../NewsletterSignupForm.deferred.css";

const SuccessMessage = ({ formatTranslation }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <>
      <h3
        ref={titleRef}
        tabIndex={-1}
        data-testid="newsletter-success-title"
        className={styles.feedbackMessage}
      >
        {formatTranslation("footer_newsletter_success_title")}
      </h3>
      <p
        data-testid="newsletter-success-message"
        className={styles.feedbackMessage}
      >
        {formatTranslation("footer_newsletter_success_generic_body")}
      </p>
    </>
  );
};

SuccessMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default SuccessMessage;
